import {
  Col,
  message,
  PageHeader,
  Row,
  Spin,
  Select,
  Space,
  Tabs,
} from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  SelectItem,
  Form,
  FormItem,
  cuentaMask,
  TableItem,
  ButtonItem,
  ErrorItem,
  RangePickerItem,
  SelectInsumosItem,
} from "../../../../Components/Items";
import { FileExcelOutlined } from "@ant-design/icons";
import {
  texto,
  identificador,
  numero,
  moneda,
  fecha,
  centro,
  fechaMexico,
  horaMexico,
  fechaHoraMexico,
  totalizar,
  construirHojaTabla,
  descargarLibro,
  limpiarNombreArchivo,
} from "../../../../Components/ExcelTablaReporte";
import { fmtFechaHoraMexico } from "../../../../Components/fechaHoraMexico";
import moment from "moment";
import "moment/locale/es";
import dayjs from "dayjs";

moment.locale("es");

const { Option } = Select;
const { TabPane } = Tabs;

class ReporteEntradasSalidasDetallado extends Component {
  state = {
    loading: false,
    objetoProyectos: null,
    todasProyectos: null,
    objetoUniadesDeNegocio: null,
    todasUniadesDeNegocio: null,
    dataReporte: null,
    todasInventario: [],
    mostrarApartados: false,
    filtrosConsultados: null,
  };

  atras() {
    this.props.history.goBack();
  }

  async componentDidMount() {
    this.setState({ loading: true });
    await axios
      .post(
        "proyectos/selectProyectos",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({ todasProyectos: res.data });
          this.setState({
            objetoProyectos: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {value.nombre}
              </Option>
            )),
          });
        }
      });
    await axios
      .post(
        "unidadesdenegocio/selectUnidadesDeNegocio",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({ todasUniadesDeNegocio: res.data });
          this.setState({
            objetoUniadesDeNegocio: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {cuentaMask(
                  value.nivel1 +
                    value.nivel2 +
                    value.nivel3 +
                    value.nivel4 +
                    value.nivel5
                ) +
                  " - " +
                  value.nombre}
              </Option>
            )),
          });
        }
      });
    this.consultarReporte({
      periodo: [moment().subtract(1, "month"), moment()],
    });
  }

  consultarReporte(values) {
    this.setState({ loading: true });
    axios
      .post(
        "reportesDeInventario/reporteEntradasSalidasDetallado",
        { ...values, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            loading: false,
            dataReporte: res.data,
            todasInventario: res.data.movimientos,
            filtrosConsultados: values,
          });
        } else {
          message.error("Ha sucedido un error y no se cargó bien el reporte");
          this.setState({ loading: false });
        }
      });
  }

  /** El periodo y los filtros con que se consultó, para la banda del Excel. */
  descripcionFiltros() {
    const filtros = this.state.filtrosConsultados || {};
    const partes = [];
    const [inicio, fin] = filtros.periodo || [];
    if (inicio && fin) {
      partes.push(`Del ${moment(inicio).format("DD/MM/YYYY")} al ${moment(fin).format("DD/MM/YYYY")}`);
    }
    if (filtros.filtrarProyecto === 1 && filtros.proyectos?.length) {
      partes.push(`${filtros.proyectos.length} proyecto(s)`);
    }
    if (filtros.filtrarProyecto === 2 && filtros.unidadDeNegocioId) {
      const unidad = (this.state.todasUniadesDeNegocio || []).find(
        (value) => value._id === filtros.unidadDeNegocioId
      );
      if (unidad) partes.push(`Unidad de negocio: ${unidad.nombre}`);
    }
    if (filtros.insumos?.length) partes.push(`${filtros.insumos.length} insumo(s)`);
    return partes.join(" - ");
  }

  /** El sufijo del nombre de archivo: el periodo, no la fecha de descarga. */
  sufijoPeriodo() {
    const [inicio, fin] = this.state.filtrosConsultados?.periodo || [];
    if (!inicio || !fin) return moment().format("YYYY-MM-DD");
    return `${moment(inicio).format("YYYY-MM-DD")}_a_${moment(fin).format("YYYY-MM-DD")}`;
  }

  construirTabla(movimientos) {
    const redondear = (valor, decimales) =>
      valor === null || valor === undefined
        ? valor
        : Math.round(Number(valor) * 10 ** decimales) / 10 ** decimales;

    const columnas = [
      { titulo: "Fecha", tipo: "fecha", ancho: 12 },
      { titulo: "Folio Movimiento", tipo: "identificador", ancho: 14 },
      { titulo: "Folio Movimiento Tipo", tipo: "identificador", ancho: 14 },
      { titulo: "Tipo Documento", tipo: "texto", ancho: 20 },
      { titulo: "Folio Documento", tipo: "identificador", ancho: 14 },
      { titulo: "Fecha Creación Documento", tipo: "fecha", ancho: 14 },
      { titulo: "Hora Creación Documento", tipo: "hora", ancho: 12 },
      { titulo: "Cód. Proveedor", tipo: "identificador", ancho: 14 },
      { titulo: "Cliente / Proveedor", tipo: "texto", ancho: 34 },
      { titulo: "Clave", tipo: "identificador", ancho: 16 },
      { titulo: "Descripción", tipo: "texto", ancho: 40 },
      { titulo: "Familia", tipo: "texto", ancho: 18 },
      { titulo: "Proyecto", tipo: "texto", ancho: 20 },
      { titulo: "Proyecto Origen", tipo: "texto", ancho: 20 },
      { titulo: "Proyecto Destino", tipo: "texto", ancho: 20 },
      { titulo: "Unidad", tipo: "texto", ancho: 12 },
      { titulo: "Unidad Compra", tipo: "texto", ancho: 12 },
      { titulo: "Factor Conversión", tipo: "numero", ancho: 12 },
      { titulo: "Cantidad Compra", tipo: "numero", ancho: 12 },
      { titulo: "Costo Moneda Compra", tipo: "moneda", ancho: 16 },
      { titulo: "Moneda Compra", tipo: "centro", ancho: 10 },
      { titulo: "Tipo de Cambio", tipo: "numero", ancho: 10 },
      { titulo: "Costo Total Moneda Compra", tipo: "moneda", ancho: 18 },
      { titulo: "Costo Unitario", tipo: "moneda", ancho: 16 },
      { titulo: "Cantidad", tipo: "numero", ancho: 12 },
      { titulo: "Costo Total", tipo: "moneda", ancho: 16 },
      { titulo: "Lote", tipo: "identificador", ancho: 16 },
      { titulo: "Caducidad", tipo: "fecha", ancho: 12 },
      { titulo: "Referencia", tipo: "texto", ancho: 24 },
      { titulo: "Código Remisión", tipo: "identificador", ancho: 16 },
      { titulo: "Observaciones", tipo: "texto", ancho: 30 },
      { titulo: "Concepto", tipo: "texto", ancho: 36 },
      { titulo: "Responsable", tipo: "texto", ancho: 26 },
      { titulo: "Hora Recibido", tipo: "fechaHora", ancho: 17 },
    ];

    const filas = movimientos.map((v) => [
      fechaMexico(v.createdAt),
      identificador(v.folioMovimiento),
      identificador(v.folioMovimientoTipo),
      texto(v.tipoDocumento),
      identificador(v.folioDocumento),
      fechaMexico(v.fechaCreacionDocumento),
      horaMexico(v.fechaCreacionDocumento),
      identificador(v.codigoProveedor),
      texto(v.clienteProveedor),
      identificador(v.claveInsumo),
      texto(v.descripcionInsumo),
      texto(v.nombreFamilia),
      texto(v.proyectoNombre),
      texto(v.proyectoOrigenNombre),
      texto(v.proyectoDestinoNombre),
      texto(v.nombreUnidad),
      texto(v.unidadCompra),
      numero(v.factorConversion),
      numero(v.cantidadCompra),
      moneda(v.costoMonedaDeCompra),
      centro(v.monedaDeCompraClave),
      numero(v.tipoDeCambioCompra),
      moneda(v.costoTotalMonedaCompra),
      // El costo unitario va por unidad de inventario: con factor de conversion
      // queda con mas de 2 decimales y redondearlo descuadra Cantidad x Costo.
      moneda(redondear(v.costoUnitario, 6)),
      numero(redondear(v.cantidad, 2)),
      moneda(redondear(v.costoTotal, 2)),
      identificador(v.lote),
      fecha(v.caducidad),
      texto(v.referencia),
      identificador(v.codigoRemision),
      texto(v.observaciones),
      texto(v.concepto),
      texto(v.nombreUsuario),
      fechaHoraMexico(v.horaRecibido),
    ]);

    // Solo se totaliza el Costo Total: las demas columnas de dinero son precios
    // unitarios o vienen en la moneda de cada compra, y sumarlas no significa nada.
    const indiceCostoTotal = columnas.findIndex((columna) => columna.titulo === "Costo Total");
    const totales = totalizar(columnas, filas).map((total, indice) =>
      indice === indiceCostoTotal ? total : null
    );

    return { columnas, filas, totales };
  }

  descargarExcel(salidas) {
    const etiqueta = salidas ? "Salidas" : "Entradas";
    const movimientos = this.state.todasInventario.filter((v) => !!v.salida === salidas);
    if (!movimientos.length) {
      message.warning(`No hay ${etiqueta.toLowerCase()} en el periodo seleccionado`);
      return;
    }
    descargarLibro(
      [
        {
          nombre: etiqueta,
          hoja: construirHojaTabla(this.construirTabla(movimientos), {
            titulo: `Reporte Detallado de ${etiqueta}`,
            empresaNombre: this.props.empresaNombre,
            descripcionFiltros: this.descripcionFiltros(),
          }),
        },
      ],
      limpiarNombreArchivo(`${etiqueta}_Detallado_${this.sufijoPeriodo()}`)
    );
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  render() {
    const columns = [
      {
        title: "Fecha",
        dataIndex: "createdAt",
        key: "createdAt",
        render: (v) => fmtFechaHoraMexico(v) || "—",
        sorter: (a, b) =>
          (a.createdAt || "").localeCompare(b.createdAt || ""),
        buscar: "createdAt",
        ellipsis: true,
        width: 130,
      },
      {
        title: "E / S",
        dataIndex: "salida",
        key: "salida",
        render: (_, record) => (record.salida ? "Salida" : "Entrada"),
        ellipsis: true,
        width: 70,
      },
      {
        title: "Folio Mov.",
        dataIndex: "folioMovimientoTipo",
        key: "folioMovimientoTipo",
        sorter: (a, b) =>
          (a.folioMovimientoTipo || "").localeCompare(b.folioMovimientoTipo || ""),
        buscar: "folioMovimientoTipo",
        ellipsis: true,
        width: 100,
      },
      {
        title: "Tipo Doc.",
        dataIndex: "tipoDocumento",
        key: "tipoDocumento",
        sorter: (a, b) =>
          (a.tipoDocumento || "").localeCompare(b.tipoDocumento || ""),
        buscar: "tipoDocumento",
        ellipsis: true,
        width: 110,
      },
      {
        title: "Folio Doc.",
        dataIndex: "folioDocumento",
        key: "folioDocumento",
        sorter: (a, b) =>
          (a.folioDocumento || "").localeCompare(b.folioDocumento || ""),
        buscar: "folioDocumento",
        ellipsis: true,
        width: 100,
      },
      {
        title: "Creación Doc.",
        dataIndex: "fechaCreacionDocumento",
        key: "fechaCreacionDocumento",
        render: (v) => fmtFechaHoraMexico(v) || "—",
        sorter: (a, b) =>
          (a.fechaCreacionDocumento || "").localeCompare(b.fechaCreacionDocumento || ""),
        ellipsis: true,
        width: 130,
      },
      {
        title: "Cód. Proveedor",
        dataIndex: "codigoProveedor",
        key: "codigoProveedor",
        sorter: (a, b) =>
          (a.codigoProveedor || "").localeCompare(b.codigoProveedor || ""),
        buscar: "codigoProveedor",
        ellipsis: true,
        width: 120,
        render: (v) => v ?? "—",
      },
      {
        title: "Cliente / Proveedor",
        dataIndex: "clienteProveedor",
        key: "clienteProveedor",
        sorter: (a, b) =>
          (a.clienteProveedor || "").localeCompare(b.clienteProveedor || ""),
        buscar: "clienteProveedor",
        ellipsis: true,
        width: 180,
      },
      {
        title: "Descripción",
        dataIndex: "descripcionInsumo",
        key: "descripcionInsumo",
        sorter: (a, b) =>
          (a.descripcionInsumo || "").localeCompare(b.descripcionInsumo || ""),
        buscar: "descripcionInsumo",
        ellipsis: true,
        width: 200,
      },
      {
        title: "Familia",
        dataIndex: "nombreFamilia",
        key: "nombreFamilia",
        sorter: (a, b) =>
          (a.nombreFamilia || "").localeCompare(b.nombreFamilia || ""),
        buscar: "nombreFamilia",
        ellipsis: true,
        width: 100,
      },
      {
        title: "Unidad",
        dataIndex: "nombreUnidad",
        key: "nombreUnidad",
        sorter: (a, b) =>
          (a.nombreUnidad || "").localeCompare(b.nombreUnidad || ""),
        buscar: "nombreUnidad",
        ellipsis: true,
        width: 80,
      },
      {
        title: "Cantidad",
        dataIndex: "cantidad",
        key: "cantidad",
        sorter: (a, b) => (a.cantidad || 0) - (b.cantidad || 0),
        ellipsis: true,
        width: 80,
        align: "right",
        render: (v) => (v ?? 0).toFixed(2),
      },
      {
        title: "Lote",
        dataIndex: "lote",
        key: "lote",
        sorter: (a, b) => (a.lote || "").localeCompare(b.lote || ""),
        buscar: "lote",
        ellipsis: true,
        width: 100,
        render: (v) => v ?? "—",
      },
      {
        title: "Caducidad",
        dataIndex: "caducidad",
        key: "caducidad",
        sorter: (a, b) => (a.caducidad || "").localeCompare(b.caducidad || ""),
        ellipsis: true,
        width: 100,
        render: (v) => (v ? dayjs(v).format("DD/MM/YYYY") : "—"),
      },
      {
        title: "Referencia",
        dataIndex: "referencia",
        key: "referencia",
        sorter: (a, b) => (a.referencia || "").localeCompare(b.referencia || ""),
        buscar: "referencia",
        ellipsis: true,
        width: 120,
        render: (v) => v ?? "—",
      },
      {
        title: "Código Remisión",
        dataIndex: "codigoRemision",
        key: "codigoRemision",
        sorter: (a, b) =>
          (a.codigoRemision || "").localeCompare(b.codigoRemision || ""),
        buscar: "codigoRemision",
        ellipsis: true,
        width: 120,
        render: (v) => v ?? "—",
      },
      {
        title: "Observaciones",
        dataIndex: "observaciones",
        key: "observaciones",
        sorter: (a, b) =>
          (a.observaciones || "").localeCompare(b.observaciones || ""),
        buscar: "observaciones",
        ellipsis: true,
        width: 150,
        render: (v) => v ?? "—",
      },
      {
        title: "Costo Unit.",
        dataIndex: "costoUnitario",
        key: "costoUnitario",
        sorter: (a, b) => (a.costoUnitario || 0) - (b.costoUnitario || 0),
        ellipsis: true,
        width: 100,
        align: "right",
        render: (v) =>
          v != null
            ? Number(v).toLocaleString("es-MX", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            : "—",
      },
      {
        title: "Costo Total",
        dataIndex: "costoTotal",
        key: "costoTotal",
        sorter: (a, b) => (a.costoTotal || 0) - (b.costoTotal || 0),
        ellipsis: true,
        width: 110,
        align: "right",
        render: (v) =>
          v != null
            ? Number(v).toLocaleString("es-MX", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            : "—",
      },
      {
        title: "Responsable",
        dataIndex: "nombreUsuario",
        key: "nombreUsuario",
        sorter: (a, b) =>
          (a.nombreUsuario || "").localeCompare(b.nombreUsuario || ""),
        buscar: "nombreUsuario",
        ellipsis: true,
        width: 130,
      },
      {
        title: "Hora Recibido",
        dataIndex: "horaRecibido",
        key: "horaRecibido",
        sorter: (a, b) =>
          (a.horaRecibido || "").localeCompare(b.horaRecibido || ""),
        ellipsis: true,
        width: 130,
        render: (v) => fmtFechaHoraMexico(v) || "—",
      },
    ];

    return (
      <>
        <Form
          name="reporteEntradasSalidasDetallado"
          onFinish={this.consultarReporte.bind(this)}
          onFinishFailed={this.onFinishFailed}
          initialValues={{
            periodo: [moment().subtract(1, "month"), moment()],
          }}
        >
          <PageHeader
            onBack={this.atras.bind(this)}
            title="Reporte Detallado de Entradas y Salidas"
            style={{
              border: "1px solid rgb(235, 237, 240)",
              backgroundColor: "white",
              marginBottom: 10,
            }}
            extra={
              <div style={{ display: "flex", justifyContent: "right" }}>
                <Space>
                  {this.state.dataReporte && (
                    <ButtonItem
                      blanco
                      onClick={() => this.descargarExcel(false)}
                      icon={<FileExcelOutlined />}
                    >
                      Excel Entradas
                    </ButtonItem>
                  )}
                  {this.state.dataReporte && (
                    <ButtonItem
                      blanco
                      onClick={() => this.descargarExcel(true)}
                      icon={<FileExcelOutlined />}
                    >
                      Excel Salidas
                    </ButtonItem>
                  )}
                  {this.state.todasInventario.filter((value) => value.esMovimientoApartado).length > 0 && (
                    <ButtonItem
                      type={this.state.mostrarApartados ? "primary" : "default"}
                      onClick={() => this.setState({ mostrarApartados: !this.state.mostrarApartados })}
                    >
                      {this.state.mostrarApartados
                        ? "Ocultar apartados"
                        : `Mostrar apartados (${this.state.todasInventario.filter((value) => value.esMovimientoApartado).length})`}
                    </ButtonItem>
                  )}
                  <ButtonItem
                    type="primary"
                    htmlType="submit"
                    style={{ display: "block", margin: "0 0 0 auto" }}
                  >
                    Consultar
                  </ButtonItem>
                </Space>
              </div>
            }
          />
          <Spin spinning={this.state.loading}>
            <div
              style={{
                backgroundColor: "white",
                padding: 20,
                paddingTop: 5,
                borderRadius: 5,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
              }}
            >
              <Tabs
                style={{ margin: 0 }}
                tabBarExtraContent={{
                  left: (
                    <h1 style={{ padding: 0, margin: "0 10px 0 0" }}>
                      Filtros:
                    </h1>
                  ),
                }}
              >
                <TabPane tabKey="3" key="3" forceRender tab="Periodo">
                  <FormItem
                    initialValue={[
                      moment().subtract(1, "month"),
                      moment(),
                    ]}
                    name="periodo"
                    required
                    noStyle
                  >
                    <RangePickerItem />
                  </FormItem>
                </TabPane>
                <TabPane tabKey="4" key="4" forceRender tab="Proyecto">
                  <Row>
                    <Col span={8}>
                      <FormItem
                        name="filtrarProyecto"
                        required
                        noStyle
                        initialValue={0}
                      >
                        <SelectItem width="90%" placeholder="Filtrar Proyecto">
                          <Option default value={0}>
                            Ninguno
                          </Option>
                          <Option value={1}>Proyectos</Option>
                          <Option value={2}>Unidades de negocio</Option>
                        </SelectItem>
                      </FormItem>
                    </Col>
                    <Col span={8}>
                      <FormItem shouldUpdate noStyle>
                        {({ getFieldValue }) => {
                          const filtrarProyecto =
                            getFieldValue("filtrarProyecto");
                          if (filtrarProyecto === 1) {
                            return (
                              <FormItem required name="proyectos" margin noStyle>
                                <SelectItem
                                  width="90%"
                                  placeholder="Proyectos"
                                  mode="multiple"
                                >
                                  {this.state.objetoProyectos}
                                </SelectItem>
                              </FormItem>
                            );
                          }
                          if (filtrarProyecto === 2) {
                            return (
                              <FormItem
                                required
                                margin
                                name="unidadDeNegocioId"
                                noStyle
                              >
                                <SelectItem
                                  width="90%"
                                  placeholder="Unidades de Negocio"
                                >
                                  {this.state.objetoUniadesDeNegocio}
                                </SelectItem>
                              </FormItem>
                            );
                          }
                        }}
                      </FormItem>
                    </Col>
                  </Row>
                </TabPane>
                <TabPane tabKey="5" key="5" forceRender tab="Insumos">
                  <FormItem name="insumos" margin noStyle>
                    <SelectInsumosItem
                      empresaId={this.props.empresaId}
                      headersToken={this.props.headersToken}
                      sinBorde
                      autoFocus
                      dropdownMatchSelectWidth={600}
                      mode="multiple"
                      width="100%"
                      placeholder="Insumo"
                      tiposInsumos="inventariables"
                    />
                  </FormItem>
                </TabPane>
              </Tabs>
            </div>
            <div style={{ height: 10 }}></div>
            <TableItem
              rowKey={(value) =>
                (value.insumoId || "") + (value.folioMovimiento || "") + Math.random()
              }
              columns={columns}
              dataSource={this.state.mostrarApartados ? this.state.todasInventario : this.state.todasInventario.filter((value) => !value.esMovimientoApartado)}
              size="small"
              pagination={false}
              scroll={{ x: 2630 }}
            />
          </Spin>
        </Form>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  empresaNombre: state.empresa.nombre,
});

export default connect(mapStateToProps)(ReporteEntradasSalidasDetallado);
